import { render } from "./ThemeSelector.vue?vue&type=template&id=39b76c60&scoped=true"
import script from "./ThemeSelector.vue?vue&type=script&lang=js"
export * from "./ThemeSelector.vue?vue&type=script&lang=js"

import "./ThemeSelector.vue?vue&type=style&index=0&id=39b76c60&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b76c60"]])

export default __exports__